import type { ImgHTMLAttributes } from "react";
import { cn } from "../../utils/cn";
import logo from "../../assets/brand/logo.svg";

type DsLogoProps = ImgHTMLAttributes<HTMLImageElement>;

function DsLogo ({ alt = "Logo da e-inscrição", className, ...props }: DsLogoProps) {
  return (
    <img
      alt={alt}
      className={cn("h-[1.43rem] w-[1.8rem]", className)}
      src={logo}
      {...props}
    />
  );
}

export { DsLogo };
